import _asyncToGenerator from "D:/workBag/projectDemo/vuedemo10/xmmanagement/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-cb879ed2"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "login"
};
var _hoisted_2 = {
  class: "login-body"
};
var _hoisted_3 = {
  class: "login-right"
};
var _hoisted_4 = ["src"];

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "title-font-1"
  }, "Hello!", -1);
});

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "title-font-2"
  }, "WELCOME TO MY MANAGEMENT SYSTEM", -1);
});

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h3", {
    class: "title"
  }, "后台管理登录", -1);
});

var _hoisted_8 = {
  class: "rememberPwd-body"
};

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "title-font-2",
    style: {
      "margin-top": "20px"
    }
  }, "This is an Internet of things management system", -1);
});

var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "title-font-3"
  }, "If you forget your password, please consult the administrator", -1);
});

import { onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import { User, Unlock } from "@element-plus/icons-vue";
import "@/styles/xmProject/login.css";
export default {
  __name: 'Login',
  setup: function setup(__props) {
    var store = useStore();
    var imgList = ref([{
      url: require("@/assets/01b63d600641a711013e399127ea44.jpg@1280w_1l_2o_100sh.jpg")
    }, {
      url: require("@/assets/v2-73e94c7e668662d225a700c42a7362b2_r.jpg")
    }, {
      url: require("@/assets/01b63d600641a711013e399127ea44.jpg@1280w_1l_2o_100sh.jpg")
    }, {
      url: require("@/assets/v2-73e94c7e668662d225a700c42a7362b2_r.jpg")
    }]);
    var RAMId = ref(true);
    var RAMtitle = ref("RAM账号");

    var RAMchange = function RAMchange() {
      if (RAMId.value) {
        RAMId.value = false;
        RAMtitle.value = "主账号";
        initUserId();
      } else {
        RAMId.value = true;
        RAMtitle.value = "RAM账号";
        formRef.value.resetFields();
      }
    };

    var form = ref({
      user_id: "",
      password: "",
      rememberMe: false
    });

    var checkBoxChange = function checkBoxChange(item) {
      if (item) {
        localStorage.setItem("checkPassword", item);
      } else {
        localStorage.removeItem("checkPassword");
      }
    };

    var loginButtonTitle = ref("login");
    var rules = ref({
      user_id: [{
        required: true,
        message: "请输入账号",
        trigger: "blur"
      }],
      password: [{
        required: true,
        message: "请输入密码",
        trigger: "blur"
      }]
    });
    var loginLoading = ref(false);

    var initUserId = function initUserId() {
      if (localStorage.getItem("user_id") && localStorage.getItem("password")) {
        form.value.company_id = localStorage.getItem("company_id");
        form.value.user_id = localStorage.getItem("user_id");
        form.value.password = localStorage.getItem("password"); // form.value.rememberMe = true
      }
    };

    var initCheck = function initCheck() {
      console.log(RAMtitle.value);

      if (localStorage.getItem("checkPassword")) {
        form.value.rememberMe = true;
      } else {
        form.value.rememberMe = false;
      }
    }; // 页面初始化时，赋值用户名密码


    onMounted(function () {
      initCheck(); // 按enter登录

      document.addEventListener("keydown", function (e) {
        var key = window.event.keyCode;

        if (key === 13) {
          handleLogin();
        }
      });
    });
    var formRef = ref(false);

    var handleLogin = function handleLogin() {
      loginLoading.value = true;
      loginButtonTitle.value = "login in...";
      formRef.value.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(valid) {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!valid) {
                    _context.next = 6;
                    break;
                  }

                  if (RAMtitle.value === "RAM账号") {
                    form.value.company_id = undefined;
                    form.value.rememberMe === false;
                  }

                  if (form.value.rememberMe === true) {
                    localStorage.setItem("company_id", form.value.company_id);
                    localStorage.setItem("user_id", form.value.user_id);
                    localStorage.setItem("password", form.value.password);
                  } else {
                    // localStorage.removeItem('company_id')
                    localStorage.removeItem("user_id");
                    localStorage.removeItem("password");
                  }

                  setTimeout(function () {
                    store.dispatch("app/login", form.value);
                    loginLoading.value = false;
                    loginButtonTitle.value = "login";
                  }, 500);
                  _context.next = 9;
                  break;

                case 6:
                  loginLoading.value = false;
                  loginButtonTitle.value = "login";
                  return _context.abrupt("return", false);

                case 9:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }; // 记住密码


    var remberPassword = function remberPassword(val) {
      if (val === true) {
        localStorage.setItem("company_id", form.value.company_id);
        localStorage.setItem("user_id", form.value.user_id);
        localStorage.setItem("password", form.value.password);
      } else {
        localStorage.removeItem("company_id");
        localStorage.removeItem("user_id");
        localStorage.removeItem("password");
      }
    };

    return function (_ctx, _cache) {
      var _component_el_carousel_item = _resolveComponent("el-carousel-item");

      var _component_el_carousel = _resolveComponent("el-carousel");

      var _component_svg_icon = _resolveComponent("svg-icon");

      var _component_el_input = _resolveComponent("el-input");

      var _component_el_form_item = _resolveComponent("el-form-item");

      var _component_el_checkbox = _resolveComponent("el-checkbox");

      var _component_el_button = _resolveComponent("el-button");

      var _component_el_form = _resolveComponent("el-form");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_carousel, {
        interval: 4000,
        class: "carousel-body",
        "indicator-position": "none",
        style: {
          "height": "100%"
        }
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imgList.value, function (item) {
            return _openBlock(), _createBlock(_component_el_carousel_item, {
              style: {
                "height": "100%",
                "width": "100%"
              },
              key: item
            }, {
              default: _withCtx(function () {
                return [_createElementVNode("img", {
                  style: {
                    "height": "100%"
                  },
                  src: item.url
                }, null, 8, _hoisted_4)];
              }),
              _: 2
            }, 1024);
          }), 128))];
        }),
        _: 1
      })]), _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        class: "login-form",
        model: form.value,
        rules: rules.value
      }, {
        default: _withCtx(function () {
          return [_hoisted_5, _hoisted_6, _hoisted_7, !RAMId.value ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            prop: "company_id"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_input, {
                "prefix-icon": "User",
                modelValue: form.value.company_id,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                  return form.value.company_id = $event;
                }),
                type: "text",
                "auto-complete": "off",
                placeholder: "请输入您的公司Id",
                clearable: ""
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_svg_icon, {
                    "icon-class": "user",
                    class: "el-input__icon input-icon"
                  })];
                }),
                _: 1
              }, 8, ["modelValue"])];
            }),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
            prop: "user_id"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_input, {
                "prefix-icon": "User",
                modelValue: form.value.user_id,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                  return form.value.user_id = $event;
                }),
                type: "text",
                "auto-complete": "off",
                placeholder: "请输入您的账号",
                clearable: ""
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_svg_icon, {
                    "icon-class": "user",
                    class: "el-input__icon input-icon"
                  })];
                }),
                _: 1
              }, 8, ["modelValue"])];
            }),
            _: 1
          }), _createVNode(_component_el_form_item, {
            prop: "password"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_input, {
                class: "passwordInput",
                "prefix-icon": "Unlock",
                modelValue: form.value.password,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                  return form.value.password = $event;
                }),
                type: "password",
                placeholder: "请输入您的密码",
                "show-password": ""
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_svg_icon, {
                    "icon-class": "password",
                    class: "el-input__icon input-icon"
                  })];
                }),
                _: 1
              }, 8, ["modelValue"])];
            }),
            _: 1
          }), _createElementVNode("div", _hoisted_8, [RAMtitle.value === '主账号' ? (_openBlock(), _createBlock(_component_el_checkbox, {
            key: 0,
            modelValue: form.value.rememberMe,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
              return form.value.rememberMe = $event;
            }),
            onChange: checkBoxChange,
            class: "rememberPwd"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(" 记住密码")];
            }),
            _: 1
          }, 8, ["modelValue"])) : _createCommentVNode("", true), _createVNode(_component_el_button, {
            type: "text",
            onClick: RAMchange
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(RAMtitle.value), 1)];
            }),
            _: 1
          })]), _createVNode(_component_el_form_item, {
            class: "button-item",
            style: {
              "width": "100%",
              "height": "40px"
            }
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_button, {
                class: "btn-grad",
                style: {
                  "width": "100%"
                },
                loading: loginLoading.value,
                onClick: handleLogin
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(loginButtonTitle.value), 1)];
                }),
                _: 1
              }, 8, ["loading"])];
            }),
            _: 1
          }), _hoisted_9, _hoisted_10];
        }),
        _: 1
      }, 8, ["model", "rules"])])]);
    };
  }
};